import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import { UIProvider } from './contexts/ContextProvider';
import { AuthProvider } from './contexts/AuthContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <UIProvider>
        <App />
      </UIProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
